import React from "react";
import { Drawer, Descriptions } from "antd";
import "./Home.scss";

// import defaultAvatar from "../../images/photo2.png";

class Person extends React.Component {
  state = {
    collapse: false,
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      collapse: nextProps.show,
    });
  }

  onClose = () => {
    this.setState({
      collapse: false,
    });
  };

  onSelectChange = (selectedRowKeys) => {
    console.log(selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  render() {
    const { collapse } = this.state;
    const { data } = this.props;
    return (
      <div>
        <Drawer width={360} onClose={this.onClose} visible={collapse}>
          {/* <div className="personAvatar">
            <Avatar src={data.photo || defaultAvatar} size={128} />
          </div> */}
          <div className="personInfo">
            <Descriptions bordered size="small" column={1}>
              <Descriptions.Item label="Name">{data.name}</Descriptions.Item>
              <Descriptions.Item label="NRIC/Fin no">{data.nric}</Descriptions.Item>
              <Descriptions.Item label="Type">{data.type && (data.type.slice(0,1).toUpperCase() + data.type.slice(1).toLowerCase())}</Descriptions.Item>
              <Descriptions.Item label="Device Label">{data.device_label}</Descriptions.Item>
            </Descriptions>
          </div>
        </Drawer>
      </div>
    );
  }
}

export default Person;
